module.exports = __webpack_public_path__ + "static/media/Cottonee_gaussian2.173f13b3.png";